import { useState } from 'react';

import { MangopayHostedIdvIframeDialog } from './MangopayHostedIdvIframeDialog/index.tsx';
import type { JONUM_FLOW } from './returnUrl.ts';
import { useHostedIdvIframeMode } from './useHostedIdvIframeMode.ts';
import { useStartFiatWalletIdentityVerification } from './useStartFiatWalletIdentityVerification.ts';

type Params = {
  flow?: typeof JONUM_FLOW;
  onVerificationSubmitted: () => void;
};

export const useLaunchHostedIdentityVerification = ({
  flow,
  onVerificationSubmitted,
}: Params) => {
  const iframeMode = useHostedIdvIframeMode();
  const { startIdentityVerification, loading } =
    useStartFiatWalletIdentityVerification({ flow, framed: iframeMode });
  const [hostedUrl, setHostedUrl] = useState<string | null>(null);
  const [completed, setCompleted] = useState(false);

  const launch = async () => {
    const url = await startIdentityVerification();
    if (!url) return;

    if (iframeMode) {
      setHostedUrl(url);
    } else {
      window.open(url, '_self');
    }
  };

  const onCompleted = () => {
    setCompleted(true);
    setHostedUrl(null);
  };

  const onClosed = () => {
    if (completed) {
      onVerificationSubmitted();
    }
  };

  const dialog = (
    <MangopayHostedIdvIframeDialog
      open={!!hostedUrl}
      url={hostedUrl}
      onCompleted={onCompleted}
      onClose={() => setHostedUrl(null)}
      onClosed={onClosed}
    />
  );

  return { launch, loading, iframeMode, dialog };
};
